import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  defineIfPdfCantBeShown,
  getSelectedCandidateLatestPdfResumeId,
  getSelectedCandidateLatestPdfResumePath,
} from '@collections/attachments';
import { CandidateSelectedObj } from '@collections/candidates';
import { AssociationModule, AssociationType, CandidateAdapter, Skill } from '@shared';
import { SkillsService } from '@shared/services/skills.service';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'mojo-candidate-details-container',
  templateUrl: './details.container.html',
  styleUrls: ['./details.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsContainerComponent {
  @Input() hideDetails = false;
  @Input() resumeTitleHidden = false;
  @Input() isNotAnonymized: boolean;
  @Input() fromTalentPool = false;

  emptyMessage = 'This candidate does not have a resume';
  modules = AssociationModule;
  types = AssociationType;

  hardSkills$: Observable<Array<Skill>>;
  softSkills$: Observable<Array<Skill>>;

  @Input()
  showCard = true;

  candidate$: Observable<CandidateAdapter> = this.store
    .select(CandidateSelectedObj.getCandidatesSelected())
    .pipe(
      filter((candidate) => !!candidate.id),
      tap((candidate) => {
        this.hardSkills$ = this.skillsService.getCandidateHardSkills(candidate.id);
        this.softSkills$ = this.skillsService.getCandidateSoftSkills(candidate.id);
      }),
    );
  resumeSrc$: Observable<string> = this.store.select(getSelectedCandidateLatestPdfResumePath);
  resumeId$: Observable<number> = this.store.select(getSelectedCandidateLatestPdfResumeId);
  cantShowPdf$ = this.store.select(defineIfPdfCantBeShown);

  constructor(private store: Store<{}>, private skillsService: SkillsService) {}
}
